import '../../App.css';
import React from 'react';
import {
    Box,
    Link,
    Typography
} from '@material-ui/core';

const summary = (
    <Box className="breakdown bottom-line">
        <Typography variant="body2">
            🚀 Lead Software Engineer with over a decade of experience building robust, scalable, and cloud-native applications for healthcare, logistics, and digital media. I specialize in frontend and backend development, API architecture, containerization (Docker), and full-stack solutions using Python, Flask, React, GraphQL, and cloud platforms like GCP and AWS.
        </Typography>
    </Box>
)

const experienceList = [
    {
        'title': 'Senior/Lead Software Engineer',
        'place': 'Vanderbilt Institute for Clinical and Translational Research',
        'time': 'Jan 2021 - Current',
        'link': 'https://victr.vumc.org/'
    },
    {
        'title': 'Senior Software Engineer',
        'place': 'Bellhop',
        'time': 'Sept 2018 – December 2020',
        'link': 'https://bellhop.com'
    },
    {
        'title': 'Senior Engineer',
        'place': 'Narrative Content Group',
        'time': 'Jan 2016 – Sept 2018',
        'link': 'https://narrativecontentgroup.com/'
    },
    {
        'title': 'Senior Front-End Engineer',
        'place': 'National Basketball Association (NBA Digital)',
        'time': 'Jan 2015 – Jan 2016',
        'link': 'https://nba.com'
    },
    {
        'title': 'Web Application Engineer',
        'place': 'Emory University',
        'time': 'Oct 2013 - Jan 2015'
    },
    // {
    //   'title': 'Lead Web Application Engineer (Full-stack)',
    //   'place': 'Rollins School of Public Health @ Emory',
    //   'time': 'Oct 2013 - Jan 2015'
    // },
    // {
    //   'title': 'Software Engineer (Full-stack)',
    //   'place': 'School of Medicine @ Emory - Bioinformatics Group',
    //   'time': 'July 2013 - Oct 2013'
    // },
    // {
    //   'title': 'Software Intern/Engineer (Full-stack)',
    //   'place': 'University of Georgia - USAID Research Group',
    //   'time': ' Oct 2011 - Jun 2013'
    // },
];

const openSourceContribList = [
    {
        'title': 'Raw Data Respository - All of Us (NIH) program',
        'github': 'https://github.com/all-of-us/raw-data-repository',
    }
];

const publicationList = [
    {
        'title': 'Data Explorer: A Tool for Data Exploration and Cohort Discovery in Massive Multidimensional Datasets.',
        'description': 'Pathology Informatics Summit 2014, May 13-16, 2014. Pittsburgh, PA — Best Electronic Presentation Pathology Informatics.',
        'names': 'Kazerouni, A, Tharpe, D, Sharma, A'
    },
    {
        'title': 'Federated Access to Images, Annotations and Measurements to Optimize the Review and Auditing of Imaging Data.',
        'description': 'Submitted in Clinical Trials.',
        'names': 'Ashish Sharma, Atlanta, GA; N Saghar; D Tharpe; T Pan, MS; R W Filice, MD'
    }
];

const experience = (
    <Box className="breakdown bottom-line">
        <Typography variant="body1" className="green-title section-header">
            Experience
        </Typography>
        {experienceList.map(exp =>
            <Box className='experience'>
                <Typography variant="body2" className="green-title">
                    {exp.title}
                </Typography>
                <Link underline="hover" href={exp.link} color="inherit">
                    <Typography variant="body2">
                        {exp.place}
                    </Typography>
                </Link>
                <Typography variant="body2">
                    {exp.time}
                </Typography>
            </Box>
        )}
    </Box>
)

const education = (
    <Box className="breakdown bottom-line">
        <Typography variant="body1" className="green-title section-header">
            Education
        </Typography>
        <Typography variant="body2" className="green-title">
            Bachelor of Science (B.Sc) - Computer Science
        </Typography>
        <Typography variant="body2">
            Middle Georgia State University
        </Typography>
    </Box>
)

const publications = (
    <Box className="breakdown bottom-line">
        <Typography variant="body1" className="green-title section-header">
            Publications </Typography>
        {publicationList.map(publication =>
            <Box className='experience'>
                <Typography variant="body2" className="green-title">
                    {publication.title}
                </Typography>
                <Typography variant="body2">
                    {publication.description}
                </Typography>
                <Typography variant="body2">
                    {publication.names}
                </Typography>
            </Box>
        )}
    </Box>
)

const open_source_contrib = (
    <Box className="breakdown">
        <Typography variant="body1" className="green-title section-header">
            Open-Source Contributions
        </Typography>
        {openSourceContribList.map(project =>
            <Box className='experience'>
                <Typography variant="body2" className="green-title">
                    {project.title}
                </Typography>
                <Link underline="hover" href={project.github} color="inherit">
                    <Typography variant="body2">
                        {project.github}
                    </Typography>
                </Link>
            </Box>
        )}
    </Box>
)

function Summary() {
    return (
        <>
            <Box className='summary'>
                {summary}
                {experience}
                {education}
                {publications}
                {open_source_contrib}
            </Box>
        </>
    );
}

export default Summary;
